import moment from "moment";
import React from 'react'
const json = {
    date_to: moment(new Date()).format("DD-MM-YYYY"),
    date_form: moment(new Date()).format("DD-MM-YYYY"),
    hr: '',
    name: '',
    rr : '',
    bp: '',
    bt: '',
    other: '',
    height: '',
    weight: '',
    search:'',
    id:'',
    patient_id : '',
    sat : '',
    visit_id : '',
    admission_range : moment(new Date()).subtract(30, 'days').format("DD-MM-YYYY")+' - '+moment(new Date()).format("DD-MM-YYYY"),
    created_range : moment(new Date()).subtract(30, 'days').format("DD-MM-YYYY")+' - '+moment(new Date()).format("DD-MM-YYYY"),
    discharge_range : '',
    //discharge_range :  moment(new Date()).format("DD-MM-YYYY")+' - '+moment(new Date()).format("DD-MM-YYYY"),
    fullname :'',
    staff_name : '',
    an :'',
    hn : '',
    admission_date : '',
    discharge_date: '',
    dc_status : '',
    principal_diagnosis : '',
    admission_status : '',
    admission_id :'',
    discharge_id :'',
    op_note_status : '',
    pageSize: '',
    page: '',
    pageTotal: '',
    recordTotal: '',
    basket_status:''
}

export default json;
